import TagManager from "react-gtm-module";

export function sendAdvancedSearchEvent(filters) {

  // Reset and push the event data to the GTM dataLayer.
  // This will prevent previous data from being submitted to GA as GTM dataLayer values persist between calls.
  const resetDataLayer = {
    event: undefined,
    searchTerm: undefined,
    states: undefined,
    zipCodes: undefined,
    counties: undefined,
    districts: undefined,
    sbaCertifications: undefined,
    sbaCertificationsIsPreviousCert: undefined,
    sbaCertificationsOperator: undefined,
    naicsSearch: undefined,
    naicsIsPrimary: undefined,
    selfCertifications: undefined,
    keywordSearch: undefined,
    keywordOperator: undefined,
    lastUpdated: undefined,
    samStatus: undefined,
    qualityAssuranceStandards: undefined,
    constructionIndividual: undefined,
    constructionAggregate: undefined,
    serviceIndividual: undefined,
    serviceAggregate: undefined,
    numberOfEmployees: undefined,
    numberOfEmployeesOperator: undefined,
    annualGrossRevenue: undefined,
    annualGrossRevenueOperator: undefined,
  };

  TagManager.dataLayer({
    dataLayer: resetDataLayer,
  });

  // Push event data to the GTM dataLayer for GA tracking
  const queryDataLayer = {
    event: 'sbsQuery',
    searchTerm: filters.searchProfiles.searchTerm,
    states: filters.location.states,
    zipCodes: filters.location.zipCodes,
    counties: filters.location.counties,
    districts: filters.location.districts,
    //sbaCertifications: filters.sbaCertifications.activeCerts.map(item => item.label),
    sbaCertifications: filters.sbaCertifications.activeCerts,
    sbaCertificationsIsPreviousCert: filters.sbaCertifications.isPreviousCert,
    sbaCertificationsOperator: filters.sbaCertifications.operatorType,
    naicsSearch: filters.naics.codes,
    naicsIsPrimary: filters.naics.isPrimary,
    selfCertifications: filters.selfCertifications.certifications,
    keywordSearch: filters.keywords.list,
    keywordOperator: filters.keywords.operatorType,
    lastUpdated: filters.lastUpdated.date.value,
    samStatus: filters.samStatus.isActiveSAM,
    qualityAssuranceStandards: filters.qualityAssuranceStandards.qas,
    constructionIndividual: filters.bondingLevels.constructionIndividual,
    constructionAggregate: filters.bondingLevels.constructionAggregate,
    serviceIndividual: filters.bondingLevels.serviceIndividual,
    serviceAggregate: filters.bondingLevels.serviceAggregate,
    numberOfEmployees: filters.businessSize.numberOfEmployees,
    numberOfEmployeesOperator: filters.businessSize.relationOperator,
    annualGrossRevenue: filters.annualRevenue.annualGrossRevenue,
    annualGrossRevenueOperator: filters.annualRevenue.relationOperator,
  };

  TagManager.dataLayer({
    dataLayer: queryDataLayer,
  });
}

